import { render, staticRenderFns } from "./SendItemEmails.vue?vue&type=template&id=76dce048&scoped=true&"
import script from "./SendItemEmails.vue?vue&type=script&lang=js&"
export * from "./SendItemEmails.vue?vue&type=script&lang=js&"
import style0 from "./SendItemEmails.vue?vue&type=style&index=0&id=76dce048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dce048",
  null
  
)

export default component.exports